import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarComponent } from './calendar/calendar.component';
import { DataDictionaryComponent } from './data-dictionary/data-dictionary.component';
import { CalendarUpdateComponent } from './calendar-update/calendar-update.component';
import { BannerConfigComponent } from './banner-config/banner-config.component';
import { AuthGaurdService } from '../service/auth-gaurd.service';


const routes: Routes = [
  {path:'calendar', component:CalendarComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] } },
  {path:'data-dictionary', component:DataDictionaryComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] } },
  {path:'calendar-update', component:CalendarUpdateComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] } },
  {path:'banner-config', component:BannerConfigComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigRoutingModule { }
